var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MailboxPicker',{attrs:{"account":_vm.account,"selected":_vm.destMailboxId,"loading":_vm.moving,"picked-mailbox":_vm.mailbox,"allow-root":true,"label-select":_vm.t('mail', 'Move'),"label-select-loading":_vm.t('mail', 'Moving')},on:{"update:selected":function($event){_vm.destMailboxId=$event},"select":_vm.onMove,"close":_vm.onClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }